export default __webpack_public_path__ + "static/media/Halter_Jersy_spots_Final_2.57913b6d.png";